import { Card, ErrorContainer, icons, useModal, useMounted, sizing } from '@chillibean/component-library';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { AdminHeroBox } from '../../../../../HeroBox/AdminHeroBox/AdminHeroBox';
import { AdminList } from '../../../Protocols/components/container';
import { fetchCohorts } from '../../redux/actions';
import { CohortModal } from './CohortModal';

export function CohortsContainer() {
  // HOOKS
  // Store
  const dispatch = useDispatch();
  const { account, authenticityToken } = useSelector((state) => state.internalReducer.internal);
  const { data: cohorts, error, loading } = useSelector((state) => state.cohortsReducer.cohorts);
  // Custom
  const {
    closeModal: closeCohortModal,
    data: selectedCohort,
    modalOpen: cohortModalOpen,
    openModal: openCohortModal,
  } = useModal();
  const { mounted } = useMounted({ requiredValues: [account, authenticityToken] });

  useEffect(() => {
    if (mounted) {
      dispatch(fetchCohorts());
    }
  }, [mounted]);

  const onClick = (id) => {
    const cohortToSelect = cohorts.find((cohort) => cohort.id === id);
    openCohortModal(cohortToSelect);
  };

  const handleRetry = () => {
    dispatch(fetchCohorts());
  };

  if (error) return <ErrorContainer error={error} retry={handleRetry} />;

  return (
    <>
      <CohortModal
        cohort={selectedCohort}
        onClose={closeCohortModal}
        onSuccess={closeCohortModal}
        visible={cohortModalOpen}
      />
      <Container>
        <BoxContainer>
          <AdminHeroBox
            button={{ text: 'Create New', onClick: () => openCohortModal() }}
            content="Info about cohorts"
            header="COHORTS:"
            icon={icons.baselineFormatBulletList}
            subHeader="Cohort List"
          />
        </BoxContainer>
        <ListContainer>
          {!loading && !cohorts.length && <Card disabled>No cohorts defined</Card>}
          {(loading || Boolean(cohorts.length)) && (
            <AdminList elements={cohorts.map((cohort) => cohort.listParams({ onClick }))} loading={loading} />
          )}
        </ListContainer>
      </Container>
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizing.medium};

  padding: ${sizing.xlarge};
`;

const BoxContainer = styled.div`
  padding: 0 15px;
`;

const ListContainer = styled.div`
  padding: 0 15px;
`;

export default CohortsContainer;
